import $ from 'jquery';
import {createRandomId, is_function, is_array, is_defined} from '../../../Helpers/js';
import {pubsub} from '../../../Core/PubSub';

$.widget('lp.lpForm', {
  options: {
    validate: null,
    success: null,

    activeSlide: 0,
    onNextSlide: null,
    onPrevStep: null,
    disableSubmit: false,
    stepsClass: '',
    sliding: true,
    translate: (text) => text,
    submit: null,
  },

  $wrapper: null, // form itself or modal around it
  $form: null,
  $slides: null,
  $inputs: null,
  $nextButton: null,
  $prevButton: null,
  $submitButton: null,
  activeSlide: 0,
  name: '',
  isFinished: false,
  subscriptions: [],

  _create: function () {
    this.$id = createRandomId();
    this.$form = this.element;
    this.name = this.$form.data('form'); // use for debugging

    // extend, if we have more cases
    var $wrapper = this.element.closest('.ui.modal');
    this.$wrapper = $wrapper.length > 0 ? $wrapper : this.$form;

    this.$wrapper.on('keydown.' + this.$id, this, this._catchKeys);
    if (this.options.sliding) {
      this.element.addClass('sliding');
    }
  },

  _destroy: function () {
    this.$wrapper.off('keydown.' + this.$id);
    this.subscriptions.forEach((sub) => sub.remove());
  },

  _init: function () {
    this._initForm();

    this._initButtons();
    this._initSlides();
    this._initFields();
    this._updateInputs();

    if (this.$slides.length > 1) {
      this.$inputs.first().focus();
    }
    if (typeof this.options.onLoad === 'function') {
      this.options.onLoad.call(this.element.get(0));
    }
  },

  _initForm: function () {
    var that = this;

    this.$form
      .removeAttr('action')
      .append('<input type="submit" class="hide">')
      .on('submit', function () {
        that._next();
        return false;
      });

    // just to be sure, that forms are not accidentally submitted and values are shown in address bar
    if (!this.$form.hasAttr('method')) {
      this.$form.attr('method', 'POST');
    }
  },

  _initFields: function () {
    var $me = this.element;
    // [auto-init="off"]: reinitialising dropdowns fails in semantic-ui right now.
    // so, we must be able to prevent auto-init
    // also we check for [tabindex] <- indicator, that it was initialized before
    $me.find('.ui.dropdown:not([auto-init="off"],[tabindex])').dropdown({showOnFocus: false});
    $me.find('.ui.checkbox:not([data-role="DblLabelCheckbox"],[tabindex])').checkbox({enableEnterKey: false});
  },

  _initButtons: function () {
    var $allsubmits = this.$wrapper.find('.approve.button,[data-role="submit-button"]'),
      $nestedSubmits = this.$wrapper.find('[data-form] .approve.button,[data-form] [data-role="submit-button"]');
    this.$submitButton = $allsubmits.not($nestedSubmits);

    this.$prevButton = this.$wrapper.find('.previous.button,[data-role="prev-button"]');
    this.$nextButton = this.$wrapper.find('.next.button,[data-role="next-button"]');
    this.$cancelButton = this.$wrapper.find('.cancel.button,[data-role="cancel-button"]');

    this.$submitButton.attr('tabIndex', '0');
    this.$prevButton.attr('tabIndex', '0');
    this.$nextButton.attr('tabIndex', '0');
    this.$cancelButton.attr('tabIndex', '0');
  },

  _initSlides: function () {
    var that = this,
      $me = this.element;

    this.activeSlide = this.options.activeSlide || 0;

    this.$slides = $me.find('[data-role="slide"],[data-role="submit-slide"]');
    this.hasSlides = this.$slides.length > 0;
    this.$submitButton.on('click', function () {
      that._next();
      return false;
    });

    if (this.hasSlides) {
      $me.addClass('multiform');
      this._initStepsDiv();
      this.$nextButton.on('click', function () {
        that._next();
        return false;
      });
      this.$prevButton.on('click', function () {
        that._back();
        return false;
      });
    } else {
      this.$slides = $me;
    }

    this.getActiveSlide().addClass('active');

    this._updateButtons();
  },

  _initStepsDiv: function () {
    var that = this,
      $wrapper = $('<div>').addClass('multiform-wrapper'),
      beforeSubmitSlide = true;

    that.$stepsDiv = $('<div>').addClass('ui small steps ' + this.options.stepsClass);
    this.element.wrap($wrapper);

    this.$slides.each(function (index, slide) {
      var $step,
        $slide = $(slide),
        innerHTML = '<i class=""></i><div class="content"><div class="title"></div><div class="description"></div></div>';

      if (beforeSubmitSlide) {
        $step = $('<a class="step">' + innerHTML + '</a>');
      } else {
        $step = $('<div class="step">' + innerHTML + '</div>');
      }
      if ($slide.data('role') == 'submit-slide') {
        beforeSubmitSlide = false;
      }
      $step.data('index', index);
      $step.find('.title').html($slide.data('title'));
      $step.find('.description').html($slide.data('desc'));
      $step.find('i').addClass($slide.data('icon'));
      that.$stepsDiv.append($step);
    });

    that.$stepsDiv.find('a.step').on('click.formStep', function () {
      that._gotoSlide($(this).data('index'));
    });
    this.element.parent().prepend(that.$stepsDiv);

    this._updateSteps();
  },

  autosave: function (on) {
    var that = this,
      $me = this.element,
      $dropdowns = $me.find('.ui.dropdown'),
      $checkboxes = $me.find('.ui.checkbox'),
      $texts = $me.find('input[type="text"],textarea'),
      callback = function () {
        return that._next();
      },
      nocallback = function () {};

    if (on) {
      $dropdowns.dropdown('setting', 'onChange', callback);
      $checkboxes.checkbox('setting', 'onChange', callback);
      $texts.on('change.textsInLpform', callback);
    } else {
      $dropdowns.dropdown('setting', 'onChange', nocallback);
      $checkboxes.checkbox('setting', 'onChange', nocallback);
      $texts.off('change.textsInLpform');
    }
  },

  addLoaderToNextButtons: function () {
    this.$submitButton.addClass('loading');
    this.$nextButton.addClass('loading');
  },

  removeLoadersFromNextButtons: function () {
    this.$nextButton.removeClass('loading');
    this.$submitButton.removeClass('loading');
  },

  _gotoSlide: function (nextSlide) {
    return nextSlide > this.activeSlide ? this._next(nextSlide) : this._back(nextSlide);
  },

  _next: function (nextSlide) {
    nextSlide = typeof nextSlide !== 'undefined' ? nextSlide : this.activeSlide + 1;
    var that = this;
    this.validate(function () {
      if (that.submitSlideActive()) {
        return that.submit(
          function () {
            that._clearErrors();
            if (!that.lastSlideActive()) {
              that._slideTo(nextSlide);
              that._setFinished();
            }
            return true;
          },
          function (json) {
            that._showErrors(json);
            that.removeLoadersFromNextButtons();
            return true;
          }
        );
      } else {
        that._slideTo(nextSlide);
      }
    });

    return false;
  },

  _back: function (nextSlide) {
    if (!this.firstSlideActive()) {
      if (is_function(this.options.onPrevStep)) {
        var prevResult = this.options.onPrevStep(this.activeSlide, this.$slides.get(this.activeSlide));
        if (prevResult === false) {
          return;
        }
      }
      nextSlide = typeof nextSlide !== 'undefined' ? nextSlide : this.activeSlide - 1;
      this._slideTo(nextSlide);
    }
  },

  submit: function (onSuccess, onError) {
    if (this.options.disableSubmit) {
      return;
    }

    if (this.$submitButton.length > 0 && !this.$submitButton.is(':visible')) {
      return false;
    }

    var that = this,
      $me = this.element,
      $forms = $me.find('form').add($me.filter('form'));

    that.addLoaderToNextButtons();
    if (is_function(this.options.submit)) {
      this.options.submit.call(this, $forms.serializeObject(), onSuccess, onError);
    } else {
      that.removeLoadersFromNextButtons();
      is_function(onSuccess) && onSuccess();
    }

    return true;
  },

  validate: function (onSuccess, onError) {
    var that = this;
    that.addLoaderToNextButtons();

    if (!that._validate()) {
      that.removeLoadersFromNextButtons();
      is_function(onError) && onError();
      return true;
    }

    var $activeSlide = this.getActiveSlide(),
      $forms;

    // find all nested forms with validation-url, but not the ones with [data-form="..."],
    // because these need to be manually validated via jQuery.<name>Form('validate');
    $forms = $activeSlide.find('[data-validation-url]:not([data-form])');

    // add "me" if got a validation-url
    if ($activeSlide.data('validation-url')) {
      $forms = $forms.add($activeSlide);
    }

    that._validateNestedForms($forms, function (success) {
      that.removeLoadersFromNextButtons();
      if (success) {
        is_function(onSuccess) && onSuccess();
      } else {
        is_function(onError) && onError();
      }
    });
  },

  _validateNestedForms: function ($forms, callback) {
    var that = this,
      cnt = $forms.length;

    if (cnt > 0) {
      $forms.each(function (index, form) {
        var $form = $(form),
          success = function (params) {
            cnt--;

            pubsub.publish('formValidated.' + $form.data('form'), {json: params, $form: $form});
            that._clearErrors($form);
            if (cnt == 0) {
              is_function(callback) && callback(true);
            }
            return true;
          },
          failed = function ({errors, ...params}) {
            cnt--;

            pubsub.publish('formNotValidated.' + $form.data('form'), {json: {...params}, $form: $form});

            that._showErrors({errors: errors}, $form);
            if (cnt == 0) {
              is_function(callback) && callback(false);
            }
            return true;
          };
        window.Browser.send($form.data('validation-url'), $form.serializeObject(), success, failed);
      });
    } else {
      is_function(callback) && callback(true);
    }
  },

  firstSlideActive: function () {
    return this.activeSlide == 0;
  },
  countSlides: function () {
    return this.$slides ? this.$slides.length : 0;
  },
  lastSlideActive: function () {
    return this.activeSlide == this.$slides.length - 1;
  },
  submitSlideActive: function () {
    return this.$slides.length == 1 || this.getActiveSlide().data('role') == 'submit-slide';
  },
  getActiveSlide: function () {
    return this.$slides.eq(this.activeSlide);
  },

  _updateButtons: function () {
    if (this.isFinished) {
      this.$prevButton.hide();
      this.$nextButton.hide();
      this.$submitButton.hide();
    } else {
      this.$prevButton.toggle(!this.firstSlideActive());
      this.$nextButton.toggle(!this.lastSlideActive() && !this.submitSlideActive());
      this.$submitButton.toggle(this.submitSlideActive());
    }
  },

  _updateSteps: function () {
    var $steps = this.$stepsDiv.find('.step');
    if (this.isFinished) {
      $steps.filter(':not(.active)').addClass('disabled').off('click.formStep');
    } else {
      $steps.filter('.active').removeClass('active');
      $steps.filter(':nth-child(' + (this.activeSlide + 1) + ')').addClass('active');
    }

    $steps.removeClass('completed');
    for (var i = 0; i < $steps.length; i++) {
      if ($steps.eq(i).hasClass('active')) {
        break;
      }
      $steps.eq(i).addClass('completed');
    }
  },

  _updateInputs: function () {
    var that = this,
      $slide = this.getActiveSlide();

    that.$inputs = $slide.find('textarea,input:not([type="hidden"]),a').filter(':visible:not(:disabled)');

    // find dropdowns, but not the one with a search-field.
    // search-fields are caught in the list above
    $slide.find('.ui.dropdown:visible').each(function () {
      var $d = $(this);
      if ($d.find('input:not([type="hidden"]):visible').length == 0) {
        that.$inputs = that.$inputs.add($d);
      }
    });

    // add buttons
    if (that.$prevButton.is(':visible')) {
      that.$inputs = that.$inputs.add(that.$prevButton);
    }
    if (that.$nextButton.is(':visible')) {
      that.$inputs = that.$inputs.add(that.$nextButton);
    }
    if (that.$submitButton.is(':visible')) {
      that.$inputs = that.$inputs.add(that.$submitButton);
    }
    if (that.$cancelButton.is(':visible')) {
      that.$inputs = that.$inputs.add(that.$cancelButton);
    }
  },

  _slideTo: function (slideIndex) {
    var slidingDistance = this.activeSlide - slideIndex,
      that = this,
      timer,
      setFocus = function () {
        that._updateInputs();
        that.$inputs.first().focus();
      };

    that.element.find(':focus').blur();

    if (this.options.sliding) {
      this.$slides.animate({left: '+=' + slidingDistance * 100 + '%'}, 300, function () {
        clearTimeout(timer);
        timer = setTimeout(setFocus, 20);
      });
    }

    this.activeSlide = slideIndex;
    that.$slides.removeClass('active').eq(slideIndex).addClass('active');
    this._updateButtons();
    this._updateSteps();
    this._updateInputs();
    this._refreshSticky();
  },

  _refreshSticky: function () {
    let that = this,
      $stickies = that.element.find('.ui.sticky');

    $stickies.each(function (index, sticky) {
      let $sticky = $(sticky);

      if ($sticky.is(':visible')) {
        $sticky.sticky('refresh');
      }
    });
  },

  _showErrors: function (json, $form) {
    let msg = [];
    if (json.errors && is_array(json.errors)) {
      msg = json.errors;
    }

    let msgs = msg.map((msg) => this.options.translate(msg));
    this.showError(msgs.join('<br>'), $form);
  },

  showError: function (messages, $form) {
    $form = $form || this.getActiveSlide().eq(0);
    var $message = $form.find('>.ui.warning.message');
    if ($message.length == 0) {
      $message = $('<div>').addClass('ui warning message');
      $form.prepend($message);
    }

    $message.html(messages);
    if (!$message.is(':visible')) {
      // $message.transition('slide');
      $message.show();
    } else {
      $message.transition('pulse');
    }

    pubsub.publish('ErrorMessageShown');
  },

  _clearErrors: function ($form) {
    $form = $form || this.element;
    var $message = $form.find('>.ui.warning.message');
    if ($message.is(':visible')) {
      $message.fadeOut('fast', () => $message.remove());
    }
  },

  _setFinished: function () {
    this.isFinished = true;

    this._updateButtons();
    this._updateSteps();

    this.options.submit = null;
    this.options.disableSubmit = true;
  },

  _catchKeys: function (evt) {
    var evtk = evt ? evt : event ? event : null;
    var node = evtk.target ? evtk.target : evtk.srcElement ? evtk.srcElement : null;
    var multiform = evtk.data;

    if (multiform.options.disableSubmit) {
      return true;
    }

    if (!multiform.$wrapper.is(':visible') || !multiform.$wrapper.is(':focus')) {
      return true;
    }

    if (multiform.countSlides() > 1 && node.type !== 'text' && node.type !== 'password' && node.type !== 'textarea') {
      // right arrow => next
      if (evtk.keyCode == 39) {
        multiform._next();
        return false;
      }

      // backspace, left arrow => back
      if (evtk.keyCode == 8 || evtk.keyCode == 37) {
        multiform._back();
        return false;
      }
    }

    if (node.type !== 'textarea') {
      // enter => next
      if (evtk.keyCode == 13) {
        multiform._next();
        return false;
      }
    }

    // space, click divs (e.g. submitbutton, cancelbutton in modal)
    if (evtk.keyCode == 32 && !is_defined(node.type)) {
      node.click();
      return false;
    }

    // tab
    if (evtk.keyCode == 9) {
      return evtk.shiftKey ? multiform._focusPrev(evtk) : multiform._focusNext(evtk);
    }

    return true;
  },

  _focusPrev: function () {
    this._updateInputs();
    var focusedInput = this._findFocusedIndex();

    // find next input to focus (that is not disabled)

    if (focusedInput == 0) {
      if (this.$slides.length > 1 || this.$wrapper.is('.ui.modal')) {
        this.$inputs.last().focus();
      } else {
        return true;
      }
    } else {
      this.$inputs.eq(focusedInput - 1).focus();
    }

    return false;
  },

  _focusNext: function () {
    this._updateInputs();
    var focusedInput = this._findFocusedIndex();

    if (focusedInput == this.$inputs.length - 1) {
      if (this.$slides.length > 1 || this.$wrapper.is('.ui.modal')) {
        this.$inputs.first().focus();
      } else {
        return true;
      }
    } else {
      this.$inputs.eq(focusedInput + 1).focus();
    }

    return false;
  },

  _findFocusedIndex: function () {
    for (var i = 0; i < this.$inputs.length; i++) {
      if (this.$inputs.eq(i).is(':focus')) {
        return i;
      }
    }

    return -1;
  },

  _validate: function () {
    // to be overwritten by parent
    return true;
  },

  _subscribe: function (topic, callback) {
    this.subscriptions.push(pubsub.subscribe(topic, callback));
  },
});
